module.exports = __webpack_public_path__ + "img/desert.2402af75.jpeg";